export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/toJSON.js
// module id = 554
// module chunks = 0